import { AMPHORA_COMPANY_ID } from "lopermut"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"

export function useIsAmphoraCompany() {
  const { data: employee } = useAuthEmployeeQuery()

  return employee?.companyId === AMPHORA_COMPANY_ID.toString()
}
